import styles from "./Impression.module.css";
import ImpressionKarte from "./ImpressionKarte/ImpressionKarte.jsx";

import impressionen1 from "../../assets/images/Impressionen/impressionen1.avif";
import impressionen2 from "../../assets/images/Impressionen/impressionen2.avif";
import impressionen3 from "../../assets/images/Impressionen/impressionen3.avif";
import impressionen4 from "../../assets/images/Impressionen/impressionen4.avif";

function Impression() {
  return (
    <div className={styles.impressionWrapper}>
      <div className={styles.impressionContainer}>
        <ImpressionKarte
          title="Unvergesslich lecker!"
          body="Das Catering von Foodosia hat unsere Firmenfeier auf ein ganz neues Level gehoben. Kreative Gerichte, perfekte Präsentation!"
          image={impressionen1}
        />
        <ImpressionKarte
          title="Einfach rundum stimmig."
          body="Von der ersten Beratung bis zum letzten Bissen: professionell, herzlich und unglaublich lecker. Unsere Gäste schwärmen heute noch!"
          image={impressionen2}
        />
        <ImpressionKarte
          title="Catering mit Seele."
          body="So persönlich, so frisch – man merkt, dass hier echte Leidenschaft dahintersteckt. Das war mehr als nur gutes Essen."
          image={impressionen3}
        />
        <ImpressionKarte
          title="Der Geschmack Mexikos."
          body="Foodosia hat unser Sommerfest kulinarisch veredelt. Besonders das mexikanische Menü war ein echtes Highlight. Gerne wieder!"
          image={impressionen4}
        />
      </div>
    </div>
  );
}

export default Impression;
